export default __webpack_public_path__ + "static/media/Monitors.fbe696d1.png";